import React from 'react'

interface IDetailsRowProps {
  title: string
  value: string
}

const DetailsRow = ({ title, value }: IDetailsRowProps): JSX.Element => {
  return (
    <div style={{ fontSize: 14, display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
      <span style={{ color: '#747894', fontWeight: 300 }}>{title}</span>
      <span style={{ fontWeight: 400 }}>{value}</span>
    </div>
  )
}

export default DetailsRow
